import {
  type DataBindingController,
  type DataBindingControllerConnection,
} from '../types'

export const setControllerConnectionsToComponent = ({
  controller,
  componentId,
  connections,
}: {
  controller: DataBindingController
  componentId: string
  connections: DataBindingControllerConnection[]
}): DataBindingController => ({
  ...controller,
  custom: {
    ...controller.custom,
    relatedConnections: {
      ...controller.custom.relatedConnections,
      [componentId]: connections,
    },
  },
})
